import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input, Switch } from "ui";

import { VariantPreview } from "../../../whatsappAdProducts.types";
import { VariantPickerField } from "./atoms";
import { AdProductFormProps, AdProductFormValues } from "./AdProductForm.types";

import styles from "./AdProductForm.module.scss";

const AdProductForm = ({ isEditing, initialPreviews }: AdProductFormProps) => {
  const { t } = useTranslation();
  const { control, register, formState } =
    useFormContext<AdProductFormValues>();

  const [variantPreviews, setVariantPreviews] = useState<VariantPreview[]>(
    initialPreviews ?? []
  );

  useEffect(() => {
    if (initialPreviews?.length) {
      setVariantPreviews(initialPreviews);
    }
  }, [initialPreviews]);

  return (
    <div className={styles.form}>
      <Controller
        control={control}
        name="sourceId"
        render={({
          field: { value, onChange },
          fieldState: { error }
        }) => (
          <Input
            label={t("Source ID (Meta ad id)")}
            placeholder={t("e.g. 120209876543210")}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            disabled={isEditing}
            errorMessage={error?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="productVariantIds"
        render={({
          field: { value, onChange },
          fieldState: { error }
        }) => (
          <VariantPickerField
            value={value ?? []}
            previews={variantPreviews}
            errorMessage={error?.message}
            onChange={(variantIds, previews) => {
              onChange(variantIds);
              setVariantPreviews(previews);
            }}
          />
        )}
      />

      <Input
        label={t("Label (optional)")}
        placeholder={t("e.g. Summer bijoux campaign — May")}
        {...register("label")}
        errorMessage={formState.errors.label?.message}
      />

      {isEditing ? (
        <Controller
          control={control}
          name="isActive"
          render={({ field: { value, onChange } }) => (
            <Switch
              label={t("Active")}
              checked={Boolean(value)}
              onChange={(e) => onChange(e.target.checked)}
            />
          )}
        />
      ) : null}
    </div>
  );
};

export default AdProductForm;
